import EDRActivityReport from './components/EDRActivityReport';

const EDRActivityReportMain = () => (
  <div>
    <div
      style={{
        display: 'flex',
        width: '100%',
        maxWidth: '100%',
        minWidth: 0,
        height: '100%',
        flexDirection: 'column',
        position: 'relative',
      }}
    >
      <EDRActivityReport />
    </div>
  </div>
);

export default EDRActivityReportMain;
